import { NOTIFICATION } from 'store/store.constants';

export const selectNotifications = (state) => state[NOTIFICATION];
export const selectFirstNotification = (state) => selectNotifications(state)?.[0];
